import {
  CREATE_NOTIFICATION,
  GET_NOTIFICATION_HISTORY,
  GET_NOTIFICATION_RECIPIENTS,
} from "@/views/csr/store/typeDefs/notification";
import notificationApiService from "@/views/csr/services/api/notification";

const notificationStoreModule = {
  actions: {
    async [GET_NOTIFICATION_RECIPIENTS](_, { search, page }) {
      try {
        const result = await notificationApiService.getRecipients(search, page);
        if (!result) return [];
        console.log(result.data);
        return result.data;
      } catch (_) {
        return [];
      }
    },

    async [CREATE_NOTIFICATION](
      _,
      { id, title, date, time, body, recipients, type }
    ) {
      try {
        const formData = new FormData();
        formData.append("type", type);
        if (id) formData.append("id", id);
        if (title) formData.append("title", title);
        if (body) formData.append("body", body);
        if (date && time) formData.append("datetime", `${date} ${time}`);
        if (recipients.length > 0) {
          const recipientsID = recipients
            .map((recipient) => recipient)
            .join(",");
          formData.append("user_list", recipientsID);
        }
        await notificationApiService.send(formData);
        return {
          success: true,
        };
      } catch (_) {
        return {
          success: false,
        };
      }
    },

    async [GET_NOTIFICATION_HISTORY](_, { page, type }) {
      try {
        const result = await notificationApiService.getHistory(page, type);
        if (!result) return [];
        return result.data;
      } catch (_) {
        return [];
      }
    },
  },
};

export default notificationStoreModule;
